<template>
    <span>
        <base-button class="btn-primary btn" :disabled="disabled" @click.native="viewItem">
            <slot name="modal-link"></slot>
        </base-button>
        <modal :show.sync="modals.classic" headerClasses="justify-content-center">
            <h4 slot="header" class="title title-up">ORDER REPORT</h4>
            <hr />
            <div class="container">
                <label style="padding-top: 10px">Name</label>
                <base-input v-model="report.name" name="report Name"></base-input>

            </div>
            <template slot="footer">
                <div class="container alert_footer">
                    <base-button type="danger" class="alert_footer_button btn_extra_small btn_info mr-4" @click.native="modals.classic = false">
                        Close
                    </base-button>
                    <base-button type="primary" class="alert_footer_button btn_extra_small btn_info" @click.native="submit">
                        Update
                    </base-button>
                </div>
            </template>
        </modal>

    </span>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { BaseButton, Modal } from '@/components'

    export default {
        name: "order-report-grid-modal",
        props: {
            isIcon: {
                type: Boolean,
                default: false
            },
            isNew: {
                type: Boolean,
                default: false
            },
            reportId: {
                type: Number,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                modals: {
                    classic: false,
                }
            };
        },
        components: {
            BaseButton,
            Modal
        },
        computed: {
            ...mapGetters({
                reports: "orderReport/reports",
                report: "orderReport/report",
                userId: "orderReport/userId"
            })
        },
        methods: {
            ...mapActions({
                getReport: "orderReport/getReport",
                clear: "orderReport/clearReport",
                getReports: "orderReport/getReports",
                getReportsByUserId: "orderReport/getReportsByUserId",
                saveReport: "orderReport/saveReport"
            }),
            viewItem() {
                let ctx = this;
                if (ctx.isNew) {
                    ctx.report.id = 0;
                    ctx.report.userId = ctx.userId;
                } 
                else {
                    ctx.getReport(ctx.reportId);
                }

                ctx.modals.classic = true
 
            },
            submit(e) {
                let ctx = this;
  
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        ctx.saveReport().then(response => {
                            if(ctx.userId)  {
                                ctx.getReportsByUserId()
                            }
                            else{
                                ctx.getReports()
                            }

                            ctx.clear();
                            ctx.$emit('report-updated');
                            ctx.modals.classic = false
                        })
                    }
                })
            },
            getError(fieldName) {
                return this.errors.first(fieldName);
            }
        }
    }
</script>
